import { render, staticRenderFns } from "./ProjectsLanding.vue?vue&type=template&id=62522234&"
import script from "./ProjectsLanding.vue?vue&type=script&lang=js&"
export * from "./ProjectsLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports